// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Rectangle } from '@shared/commons/Geometry';
import { TerceraChartWindowBase } from './TerceraChartWindowBase';
export class TerceraChartWindow extends TerceraChartWindowBase {
    constructor() {
        // #region Properties
        super(...arguments);
        this.indicatorRendererSettings = { UseInAutoscale: true };
    }
    OnLayout(info = null) {
        //    //
        //    // надо рендерить плашки индюков и оверлеев?
        //    //
        const plateRenderer = this.GetMainThreadRenderer('TerceraChartPlateRenderer');
        if ((plateRenderer != null && !plateRenderer.IsEmpty()) || this.TerceraChartOverlayWindow) {
            // this instanceof TerceraChartOverlayWindow медленный добавил флаг. сравнить на его присутствие намного быстрее, где нет this.TerceraChartOverlayWindow=undefined
            this.HeaderVisible = true;
            this.PaddingTop = this.IsMainWindow ? 0 : this.HeaderHeight;
        }
        else {
            this.PaddingTop = 0;
            this.HeaderVisible = false;
        }
        this.PaddingRight = info == null ? this.prevScaleW : info.PreferredWidthScales;
        if (info != null) {
            this.PaddingLeft = info.PreferredWidthScalesLeft;
        }
        this.UpdateClientRectangle();
        const clientR = this.ClientRectangle;
        if (this.rightYScaleRenderer) {
            this.rightYScaleRenderer.Rectangle = new Rectangle(clientR.X + clientR.Width, clientR.Y - this.PaddingTop, this.PaddingRight, clientR.Height + this.PaddingTop);
        }
        if (this.leftYScaleRenderer != null && info != null) {
            if (this.IsMainWindow) {
                //
                // Показываем левую шкалу только, когда нет оверлеев но есть задвоенные индюки
                // (Если есть оверлеи - они показывают шкалу, поэтому встроенная не нужна)
                //
                if (!info.HasOverlays && info.HasDoubledIndicator) {
                    this.leftYScaleRenderer.Visible = true;
                    this.leftYScaleRenderer.Rectangle = new Rectangle(0, clientR.Y - this.PaddingTop, info.PreferredWidthScalesLeft, clientR.Height + this.PaddingTop);
                }
                else {
                    this.leftYScaleRenderer.Visible = false;
                }
            }
            else {
                if (info.HasDoubledIndicator || info.HasOverlays) {
                    this.leftYScaleRenderer.Visible = true;
                    this.leftYScaleRenderer.Rectangle = new Rectangle(0, clientR.Y - this.PaddingTop, info.PreferredWidthScalesLeft, clientR.Height + this.PaddingTop);
                }
                else {
                    this.leftYScaleRenderer.Visible = false;
                }
            }
        }
        const headerRectangle = this.getWindowHeaderRectangle();
        this.windowHeaderRectangle = headerRectangle;
        const btnSize = headerRectangle.Height;
        this.collapserRectangle = !this.IsMainWindow
            ? new Rectangle(headerRectangle.X + headerRectangle.Width - btnSize, headerRectangle.Y, btnSize, btnSize)
            : Rectangle.Empty();
        if (plateRenderer != null && !plateRenderer.IsEmpty()) {
            // обновляем ректангл, для всех окон место на коллапсер, разделитель рисуется в виндоу контейнере
            plateRenderer.Rectangle = new Rectangle(headerRectangle.X, headerRectangle.Y, headerRectangle.Width - this.collapserRectangle.Width, headerRectangle.Height);
        }
        this.LayoutPaddingRenderers();
        if (info != null) {
            this.prevScaleW = info.PreferredWidthScales;
        }
    }
    Dispose() {
        super.Dispose();
        this.indicatorRendererSettings = null;
    }
}
